import { Caps } from "../core/Caps.js";
import { Signal } from "../core/Signal.js";
import { Calc } from "../math/Calc.js";
import { IListData, IListVisual } from "./List.js";
import { ListDynamic, ListItem } from "./ListDynamic.js";
import { Scrollbar, ScrollbarData, ScrollbarTheme } from "./Scrollbar.js";
import { IScrollbarBehaviour } from "./scrollbarbehaviour/IScrollbarBehaviour.js";
import { ScrollbarBehaviour } from "./scrollbarbehaviour/ScrollbarBehaviour.js";

export class ScrollbarListDynamic<Data extends IListData = any> extends Scrollbar {
    public readonly view: ListDynamic<Data>;
    public labelProvider: (data: Data) => string = null;
    public behaviour: IScrollbarBehaviour = ScrollbarBehaviour.INDEX;

    private _namesapce: string = Signal.getUniqueNamespace();
    private _label: HTMLDivElement;
    private _labelItem: ListItem<Data, IListVisual> = null;

    constructor(view: ListDynamic<Data>, theme: ScrollbarTheme = "lite") {
        super(false, theme)

        this.view = view;

        this._label = document.createElement("div");
        this._label.className = "e5-scrollbar-label e5-hidden";
        this.element.appendChild(this._label);

        //Re-dispatch mouse wheel event to ListDynamic.
        this.element.addEventListener("wheel", (e) => {
            if (!this.view || !this.view.scroller)
                return;
            if (this.dragger.pointers.length === 0) {
                try {
                    this.view.scroller.dispatchEvent(new WheelEvent(e.type, e));
                } catch (error) {
                }
            }
        }, Caps.passiveEventLister ? {
            passive: true
        } : false);

        this.view.onUpdate.throttle(() => this.update(), 100, this, this._namesapce);
    }

    protected increment(count: number): void {
        // this._view.scrollToIndex(this._view.first.index + this.clickCountToOffset(count));
        this.view.scrollTop += this.clickCountToOffset(count) * 100;
    }

    protected decrement(count: number): void {
        // this._view.scrollToIndex(this._view.first.index - this.clickCountToOffset(count));
        this.view.scrollTop -= this.clickCountToOffset(count) * 100;
    }

    private clickCountToOffset(count: number): number {
        if (count > 9)
            return 6;
        if (count > 6)
            return 4;
        if (count > 3)
            return 2;
        return 1;
    }

    protected dragStart(): void {
        this.updateLabel();
        super.dragStart();
    }

    protected drag(): void {
        this.updateLabel();
        super.drag();
    }

    protected dragEnd(): void {
        this.scrollToByThumb();
        this._label.classList.add("e5-hidden");
        super.dragEnd();
    }

    private updateLabel(): void {
        if (this.labelProvider === null)
            return;
        var index = this.getIndex();
        var item = this.view.getItems()[index];
        this._label.classList.toggle("e5-hidden", !Boolean(item));
        if (item && this._labelItem !== item) {
            this._labelItem = item;
            this._label.innerHTML = this.labelProvider(item.data);
        }

        if (item) {
            var margin = 10;
            var labelHeight = this._label.offsetHeight;
            var yPos = this.dragger.top;
            yPos += this.thumb.offsetHeight * 0.5;
            yPos -= labelHeight * 0.5;
            yPos += this.track.offsetTop;
            yPos = Calc.clampMax(yPos, this.element.offsetHeight - (labelHeight + margin));
            yPos = Calc.clampMin(yPos, margin);
            this._label.style.transform = `translateY(${yPos}px)`;
        }
    }

    private scrollToByThumb(): void {
        // if (this.end) {
        //     this.view.scrollToBottom();
        //     return;
        // }

        var index = this.getIndex();
        if (index < 0) {
            this.view.scrollToTop();
        } else if (index >= this.view.getItems().length) {
            this.view.scrollToBottom();
        }
        else {
            this.view.scrollToIndex(index);
        }
    }

    protected getIndex(): number {
        return this.behaviour.getIndex(this);
    }

    protected getPosition(): ScrollbarData {
        return this.behaviour.fromView(this);
    }
}